import SERVICES from './services';
import DIRECTIVES from './directives';
import CONSTANTS from './constants';

export default {
    SERVICES,
    DIRECTIVES,
    CONSTANTS
}
